import {
  SB,
  createSharedStateMessage,
  createSharedStateMessages,
} from '@play-co/replicant';
import { teamCompetitionSharedStateSchema } from './teamCompetition.schema';

export const teamCompetitionMessages = createSharedStateMessages(
  teamCompetitionSharedStateSchema,
)({
  setTeams: createSharedStateMessage(
    SB.object({
      teamIds: SB.array(SB.string()),
      timestamp: SB.number().optional(),
    }),

    (state, { teamIds, timestamp }, meta) => {
      // Check if the teams are already set.
      const alreadySet = Object.keys(state.global.teams).length > 0;
      if (alreadySet) return;

      // Set the teams.
      teamIds.forEach((teamId) => {
        state.global.teams[teamId] = {
          createdAt: timestamp ?? meta.timestamp,
        };
      });
    },
  ),

  join: createSharedStateMessage(
    SB.object({
      teamId: SB.string(),
      timestamp: SB.number().optional(),
    }),
    (state, { teamId, timestamp }, meta) => {
      // Check if the team is in the competition.
      const team = state.global.teams[teamId];
      if (team) return;

      state.global.teams[teamId] = {
        createdAt: timestamp ?? meta.timestamp,
      };
    },
  ),
});
